import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';
export default Vue.extend({
    props: {
        image: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            linkRedirect: '',
            checkboxValue: false,
        };
    },
    methods: {
        ...mapMutations('alcoholModule', ['setModalShow', 'setTimestamp']),
        alcoholShowModal(linkPage) {
            this.linkRedirect = linkPage;
            if (this.canShow()) {
                this.$bvModal.show('alcoholmodal');
            }
            else {
                this.redirect();
            }
        },
        redirect() {
            if (this.canShow() && this.checkboxValue === true) {
                this.setModalShow(true);
                this.setTimestamp(Date.now());
            }
            window.location.href = this.linkRedirect;
        },
        canShow() {
            if (this.modalShow !== true) {
                return true;
            }
            var timeTmp = new Date(this.timestamp);
            timeTmp.setTime(timeTmp.getTime() + 24 * 60 * 60 * 1000);
            if (Date.now() > timeTmp.getTime()) {
                return true;
            }
            return false;
        },
        attachClickToShowModal() {
            const elements = document.getElementsByClassName('showAlcoholModal');
            for (var i = 0; i < elements.length; i++) {
                const link = elements[i].getAttribute('href');
                elements[i].onclick = (event) => {
                    event.preventDefault();
                    if (link)
                        this.alcoholShowModal(link);
                };
            }
        },
    },
    computed: {
        ...mapState('alcoholModule', ['modalShow', 'timestamp']),
    },
    created() {
        this.$root.$refs.AlcoholAlert = this;
    },
    mounted() {
        const elements = document.getElementsByClassName('showAlcoholModal');
        for (var i = 0; i < elements.length; i++) {
            const link = elements[i].getAttribute('href');
            elements[i].onclick = (event) => {
                event.preventDefault();
                if (link)
                    this.alcoholShowModal(link);
            };
        }
    },
});
